import { toNumberValue, toPlainNumberText } from './number-utils';

export function getFullName(user: any): string {
  if (!user) return '';

  if (typeof user.fullName === 'string') {
    return user.fullName;
  }

  if (typeof user.name === 'string') {
    return user.name;
  }

  let { firstName, lastName } = user;
  firstName = typeof firstName === 'string' ? firstName : '';
  lastName = typeof lastName === 'string' ? lastName : '';
  return `${firstName} ${lastName}`.trim();
}

export function getMediumName(user: any): string {
  if (!user) return '';
  let { firstName, lastName } = user;
  firstName = typeof firstName === 'string' ? firstName : '';
  lastName = typeof lastName === 'string' && lastName.length > 0 ? lastName[0].toUpperCase() + '.' : '';
  return `${firstName} ${lastName}`.trim();
}

export function getShortName(user: any): string {
  if (!user) return '';
  let { firstName, lastName } = user;
  firstName = typeof firstName === 'string' && firstName.length > 0 ? firstName[0].toUpperCase() : '';
  lastName = typeof lastName === 'string' && lastName.length > 0 ? lastName[0].toUpperCase() : '';
  return `${firstName}${lastName}`;
}

export function compareStrings(a?: string, b?: string, options?: Intl.CollatorOptions) {
  if (!a) return -1;
  if (!b) return 1;
  return a.localeCompare(b, void 0, options);
}

export function safeJSONParse(data: any): any {
  try {
    return JSON.parse(data);
  } catch (error) {
    return data;
  }
}

/**
 * A number for a reader, with its field's symbol around it.
 *
 * The text comes from `toPlainNumberText` rather than `String` so that a small number is shown the
 * way it was typed: `String(0.0000000001)` is `1e-10`, and a table cell reading `1e-10` looks like a
 * bug. Anything that is not a number has no text at all, which is the same answer an empty field
 * gives — there is nothing sensible to put in a NUMBER column for text that is not a number.
 */
export function formatNum(num: number | string | null | undefined, format?: string) {
  const str = toPlainNumberText(toNumberValue(num));
  if (!str) return '';

  return format ? format.replace('#', str) : str;
}
